module.exports = __webpack_public_path__ + "static/assets/172b64dad1cb7fb9f195c584024b2dc2.svg";